// ViewContestRegistrations.tsx
import React, { useEffect, useState } from "react";
import fetchWithAuth from "../../lib/fetchWithAuth";
import { API_BASE_URL } from "../../config";

const ViewContestRegistrations: React.FC = () => {
  const [contests, setContests] = useState<any[]>([]);
  const [selectedContestId, setSelectedContestId] = useState<number | null>(null);
  const [registrations, setRegistrations] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // Fetch all contests initially
  useEffect(() => {
    const fetchContests = async () => {
      const res = await fetchWithAuth(`${API_BASE_URL}/admin/contests`);
      const data = await res.json();
      setContests(data.contests || []);
    };
    fetchContests();
  }, []);

  // Fetch registrations when a contest is selected
  useEffect(() => {
    if (!selectedContestId) return;
    const fetchRegistrations = async () => {
      setLoading(true);
      const res = await fetchWithAuth(`${API_BASE_URL}/admin/registrations`);
      const data = await res.json();
      if (data.success) {
        const filtered = data.registrations.filter(
          (reg: any) => reg.contest_id === selectedContestId
        );
        setRegistrations(filtered);
      }
      setLoading(false);
    };
    fetchRegistrations();
  }, [selectedContestId]);

  return (
    <div className="p-6 pt-24 min-h-screen bg-gray-50">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">View Contest Registrations</h1>

      {!selectedContestId ? (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {contests.map((contest) => (
            <button
              key={contest.id}
              onClick={() => setSelectedContestId(contest.id)}
              className="bg-white p-4 rounded shadow hover:bg-indigo-50 text-left border border-gray-200"
            >
              <h2 className="font-semibold text-lg text-indigo-600">{contest.contest_name}</h2>
              <p className="text-sm text-gray-500">Questions: {contest.no_of_questions}</p>
            </button>
          ))}
        </div>
      ) : (
        <div>
          <button
            onClick={() => setSelectedContestId(null)}
            className="mb-4 text-indigo-600 hover:underline"
          >
            ← Back to Contest List
          </button>

          {loading ? (
            <p>Loading...</p>
          ) : registrations.length === 0 ? (
            <p className="text-gray-600">No registrations found for this contest.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full border bg-white shadow rounded mt-4">
                <thead className="bg-indigo-600 text-white">
                  <tr>
                    <th className="px-4 py-2">#</th>
                    <th className="px-4 py-2">User Name</th>
                    <th className="px-4 py-2">Email</th>
                    <th className="px-4 py-2">Registered At</th>
                  </tr>
                </thead>
                <tbody>
                  {registrations.map((reg, index) => (
                    <tr key={reg.registration_id} className="text-center border-b">
                      <td className="px-4 py-2">{index + 1}</td>
                      <td className="px-4 py-2">{reg.user_name}</td>
                      <td className="px-4 py-2">{reg.user_email}</td>
                      <td className="px-4 py-2">{new Date(reg.registered_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewContestRegistrations;
